import React, { memo } from 'react';

function HealthCheck() {
  return <>
 ok 
  </>;
}

export default memo(HealthCheck);